import { useUserStore } from '@/pinia/user'

const show = ref(false)

/**
 * 方便其他模块可以直接唤起 Login 模块
 */
export const useLoginModal = () => {
  const user = useUserStore()

  const open = () => {
    show.value = true
  }

  const close = () => {
    show.value = false
  }

  watch(() => user.isLogged, (logged) => {
    /**
     * 监听用户是否已登录，如果已登录则自动关闭登录弹窗
     */
    if (logged) {
      close()
    }
  })

  return {
    show,
    open,
    close
  }
}
